import React from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { logout } from '../../redux/actions'
import home from '../../Assets/images/home.png'
import profile from '../../Assets/images/profile.png'
import logout_icon from '../../Assets/images/logout.png'
import './navbar.css'

export default function Navbar() {
  const dispatch = useDispatch()
  const naviga = useNavigate()
  const { pathname } = useLocation()
  const name = pathname.split('/')[1]

  const UID = JSON.parse(localStorage.getItem('_syt2022_')).uid
  function logOut() {
    localStorage.removeItem('_syt2022_')
    dispatch(logout())
    naviga('/login')
  }
  return (
    <div className="row navContainer">
      <div
        className="col-12 td"
        style={{
          borderLeft: name === 'home' ? '4px solid #0696ff' : 0,
        }}
      >
        <Link
          to={'/home'}
          className="linkl"
          style={{
            color: name === 'home' ? '#0696ff' : 'gray',
          }}
        >
          <img src={home} alt="home" />
          Home
        </Link>
      </div>
      <div
        className="col-12 td"
        style={{
          borderLeft:
            name !== 'home' && name !== 'login' ? '4px solid #0696ff' : 0,
        }}
      >
        <Link
          to={`/${UID}`}
          className="linkl"
          style={{
            color: name !== 'home' && name !== 'login' ? '#0696ff' : 'gray',
          }}
        >
          <img src={profile} alt="profile" /> Profile
        </Link>
      </div>
      <div className="col-12 td">
        <Link
          to={'/login'}
          className="linkl"
          onClick={logOut}
          style={{ color: 'gray' }}
        >
          <img src={logout_icon} alt="logout" /> Logout
        </Link>
      </div>
    </div>
  )
}
